export default class Realisation {
  constructor(element) {
    this.element = element;
    this.cards = this.element.querySelectorAll('.realisation-card');
    this.currentCardIndex = -1;
    this.init();
  }

  init() {
    this.setSameHeight();
    window.addEventListener('resize', () => this.setSameHeight());

    const observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      {
        root: null,
        threshold: 0.5,
      }
    );

    this.cards.forEach((card) => {
      observer.observe(card);
    });

    this.cards.forEach((card, index) => {
      card.style.top = `${index * 25 + 100}px`;
    });
  }

  setSameHeight() {
    this.cards.forEach(card => {
      card.style.height = 'auto';
    });

    let maxHeight = 0;
    this.cards.forEach(card => {
      const cardBody = card.querySelector('.card-body');
      if (cardBody) {
        const height = cardBody.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      }
    });

    this.cards.forEach(card => {
      const cardBody = card.querySelector('.card-body');
      if (cardBody) {
        cardBody.style.height = `${maxHeight}px`;
      }
    });
  }

  handleIntersection(entries) {
    let intersectingIndex = -1;

    entries.forEach((entry) => {
      const index = Array.from(this.cards).indexOf(entry.target);
      const cardBackground = entry.target.querySelector('.card-bg-js');

      if (entry.isIntersecting) {
        cardBackground.classList.add('realisation-gradient-bg');
        intersectingIndex = index;

        if (
          this.currentCardIndex !== -1 &&
          this.currentCardIndex !== intersectingIndex
        ) {
          const previousCardBackground =
            this.cards[this.currentCardIndex].querySelector('.card-bg-js');
          previousCardBackground.classList.remove('gradient-bg');
        }

        this.currentCardIndex = intersectingIndex;
      } else {
        cardBackground.classList.remove('gradient-bg');
      }
    });
  }
}